<template>
  <NuxtLink
    :to="to"
    class="flex items-center gap-x-[18px] rounded-[20px] bg-[#f5f5f5] p-2 transition-colors hover:bg-black/5"
    @click="uiStore.showMenu = false"
  >
    <img :src="icon" alt="" class="size-14 flex-none" />
    <span class="text-[18px] font-medium" v-text="label" />
  </NuxtLink>
</template>

<script setup lang="ts">
interface Props {
  to: string
  label: string
  icon: string
}

defineProps<Props>()

const uiStore = useUIStore()
</script>
